var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-category nacelle"},[_vm._t("default",function(){return [_c('p',{staticClass:"product-category-text"},[_vm._v("\n      "+_vm._s(_vm.category)+"\n    ")])]},{"category":_vm.category})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }